import React, { useState } from 'react';
import Page from '../../../Components/Containers/Page';
import TopBar from '../../../Components/TopBar';
import { useTags } from '../../../Data/Tags';
import { PageLoading } from '../../../Components/Loading';
import NoItems from '../../../Components/EmptyStates/NoItems';
import TagsRow from '../../../Components/Tags/Tags';
import AddEditTag from '../../../Components/Tags/AddEditTag';
import Button from '../../../Components/Button/Button';
import Tag from '../../../Components/Tags/Tag';
import ButtonRow from '../../../Components/Button/ButtonRow';
import { useDialogues } from '../../../Components/Dialogues';

const Tags = () => {
    const {tags, deleteTag, refresh} = useTags();
    const [editTag, setEditTag] = useState(null);

    return <>
        <TopBar left="/more"
            title="Tags"
            right={<Button theme="light"
                    icon="Plus"
                    onClick={() => setEditTag({})}
                    zeroMargin
                />}
        />
        <Page>
            {tags ? <Inner {...{tags, setEditTag, deleteTag}} /> : <PageLoading />}
        </Page>

        <AddEditTag tag={editTag}
            isOpen={!!editTag}
            setIsOpen={() => setEditTag(null)}
            onSave={refresh}
        />
    </>
}

const Inner = ({tags, setEditTag, deleteTag}) => {
    const {confirm} = useDialogues();

    if (tags.length === 0) {
        return <NoItems
            icon="Tag"
            title={<>
                Customer tags<br />
                <TagsRow tags={[
                        {icon: 'Flag', colour: 'Red', name: 'Tag'},
                        {icon: 'Dog', colour: 'Blue', name: 'Dog'},
                        {icon: 'Fence', colour: 'Green', name: 'Gate'},
                    ]}
                    className="my-2"
                    center
                />
            </>}
            message="Tags help you organise your customers and jobs, and provide reminders."
            onClick={() => setEditTag({})}
        />
    }
    return <ul className="divide-y divide-gray-200">
        {tags.map(tag => <li key={tag.id} className="flex items-center justify-between py-4">
            <div>
                <Tag tag={tag} onClick={() => setEditTag(tag)} />
                {tag.dismissible && <span className="ml-3 text-muted text-sm">Temporary</span>}
            </div>
            <ButtonRow>
                <Button theme="light"
                    icon="Pencil"
                    className="my-0"
                    onClick={() => setEditTag(tag)}
                />
                <Button theme="lightDanger"
                    icon="Trash"
                    className="my-0"
                    onClick={() => confirm(
                        {
                            theme: 'danger',
                            title: 'Delete tag',
                            confirmLabel: 'Delete',
                            message: `Are you sure you want to delete the '${tag.name}' tag?\nThis cannot be undone.`,
                        },
                        () => deleteTag(tag.id),
                    )}
                />
            </ButtonRow>
        </li>)}
    </ul>
}

export default Tags;